import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import Cookie from "js-cookie";
import { getServerProps } from "./utils/server";

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/hotelx/locales/{{lng}}/{{ns}}.json",
    },
    // lng: document.querySelector("html").lang || "en", // Default to 'en' if lang attribute is missing
    lng: Cookie.get("i18nextLng") || "en", // Set default language from cookie

    fallbackLng: "en",
    ns: ["home", "login", "common", "meta", "settings"], // Ensure 'home' is included
    defaultNS: "home",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
